import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions, URLSearchParams} from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';

import { ApiService } from "../../shared/network/api.service";
import { HttpService } from '../../shared/network/http.service';
import {AuthService} from "../../shared/authentication/auth.service";



@Injectable()
export class DashboardService {

    private baseOrgUrl = function() {
        return this.apiservice.getBaseUrl() + '/organizations/' + this.authService.getSelectedOrg();
    }

    private summarysUrl = this.baseOrgUrl() + '/statistics/summary';
    private workorderUrl = this.baseOrgUrl() + '/statistics/workorders';
    private locationUrl = this.baseOrgUrl() + '/statistics/locations';
    private deficienciesUrl = this.baseOrgUrl() + '/statistics/deficiencies';

    constructor (private http: HttpService, private apiservice: ApiService, private authService: AuthService) {}


    getSummary(): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let options = new RequestOptions({ headers: headers });

        return this.http.get(this.summarysUrl, options)
            .map(this.extractSettings)
            .catch(this.handleError);
    }
    getWorkorder(): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let options = new RequestOptions({ headers: headers });

        return this.http.get(this.workorderUrl, options)
            .map(this.extractSettings)
            .catch(this.handleError);
    }
    getLocation(): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let options = new RequestOptions({ headers: headers});

        return this.http.get(this.locationUrl, options)
            .map(this.extractSettings)
            .catch(this.handleError);
    }
    getDeficiencies(lang): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});

        let params:URLSearchParams = new URLSearchParams();
        params.set('lang', lang);

        let options = new RequestOptions({ headers: headers, search: params });

        return this.http.get(this.deficienciesUrl, options)
            .map(this.extractSettings)
            .catch(this.handleError);
    }




    private extractSettings(res: Response) {
        let body = res.json();
        return body || {};
    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error.status == 404) {
            errMsg = error.statusText;
        } else {
            const body = error.json() || '';
            errMsg = body.message || JSON.stringify(body);
        }

        return Observable.throw(errMsg);
    }


}



// WEBPACK FOOTER //
// ./src/app/routes/dashboard/dashboard.service.ts